import EmailPhoneInputField from './EmailPhoneInputField.component';

export default EmailPhoneInputField;
